/**
 *
 * @class CorridorGroupBatch
 *
 * Container for gathering together multiple corridor batch simulations into one big "batch of batches".
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
import {CorridorBatch} from "@/models/batch/corridor.batch";

export class CorridorGroupBatch {

  /** the name of the big batch */
  public name: string = '';

  /** where we originally imported it from (typically an AbOvo/Quintiq dropbox folder */
  public src: string  = '';

  /** the set of corridors (batches) in this batch group */
  public corridors: Map<string, CorridorBatch> = new Map<string, CorridorBatch>();

  constructor(name: string, src: string) {

    this.name = name;
    this.src = src;
  }


}

